(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gsq-faq"] && !Shopify.designMode) return;
  try {
    
  const faqSections = document.querySelectorAll('[data-gsq-faq]');

  faqSections.forEach((faqSection) => {
    if (!(faqSection instanceof HTMLElement)) return;

    const navLinks = faqSection.querySelectorAll('[data-gsq-faq-nav-link]');
    const categories = faqSection.querySelectorAll('[data-gsq-faq-category]');
    const select = faqSection.querySelector('[data-gsq-faq-select]');

    const setActiveLink = (targetId) => {
      navLinks.forEach((link) => {
        if (!(link instanceof HTMLElement)) return;
        link.classList.toggle('is-active', link.dataset.targetId === targetId);
      });
    };

    const scrollToCategory = (targetId) => {
      const target = document.getElementById(targetId);
      if (!target) return;

      const headerOffset =
        parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-group-height'), 10) || 0;
      const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - 16;

      window.scrollTo({
        top,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
      setActiveLink(targetId);
    };

    navLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        if (!(link instanceof HTMLElement) || !link.dataset.targetId) return;
        scrollToCategory(link.dataset.targetId);
      });
    });

    if (select instanceof HTMLSelectElement) {
      select.addEventListener('change', () => {
        if (!select.value) return;

        const selectedOption = select.selectedOptions[0];
        if (selectedOption?.dataset.gsqFaqExternal === 'true') {
          window.location.href = select.value;
          return;
        }

        scrollToCategory(select.value);
      });
    }

    if ('IntersectionObserver' in window && categories.length > 0) {
      const observer = new IntersectionObserver(
        (entries) => {
          const visible = entries
            .filter((entry) => entry.isIntersecting)
            .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];

          if (visible?.target?.id) {
            setActiveLink(visible.target.id);
            if (select instanceof HTMLSelectElement && select.value !== visible.target.id) {
              select.value = visible.target.id;
            }
          }
        },
        {
          rootMargin: '-20% 0px -55% 0px',
          threshold: [0, 0.25, 0.5, 0.75, 1],
        }
      );

      categories.forEach((category) => observer.observe(category));
    } else if (navLinks[0] instanceof HTMLElement && navLinks[0].dataset.targetId) {
      setActiveLink(navLinks[0].dataset.targetId);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
